export default {
  fromValue (val) {
    switch (val) {
      case 'accountant':
        return 'Contador'
      case 'admin':
        return 'Administrador'
      case 'assistant':
        return 'Assistente'
      case 'basic':
        return 'Básico'
      case 'director':
        return 'Diretor'
      case 'instructor':
        return 'Instrutor'
      case 'manager':
        return 'Gerente'
      default:
        return val
    }
  }
}
